import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col items-center justify-center m-2" }
const _hoisted_2 = { class: "py-4 text-gray-700" }
const _hoisted_3 = { class: "text-xs" }
const _hoisted_4 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_5 = { class: "text-xs" }
const _hoisted_6 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_7 = { class: "error-message" }
const _hoisted_8 = { class: "text-xs" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineButton = _resolveComponent("LineButton")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_BaseCard = _resolveComponent("BaseCard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseCard, { class: "sm:w-6/12 text-center" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("p", null, _toDisplayString(_ctx.entryablePeriodText), 1),
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.entryable_period_option.entryable_begin_at) + " ~ " + _toDisplayString(_ctx.entryable_period_option.entryable_end_at), 1),
          (!_ctx.is_loginable)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.campaignIsClosedMessage), 1)
              ]))
            : (!_ctx.is_entryable)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.outOfCampaignEntryablePeriodMessage), 1),
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.outOfCampaignEntryablePeriodalreadyEntryedMessage), 1)
                ]))
              : _createCommentVNode("", true)
        ]),
        (_ctx.is_loginable)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.authenticatorRegistrations, (authenticatorRegistration) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: authenticatorRegistration.url_code
                }, [
                  (authenticatorRegistration.authentication_type === 'line')
                    ? (_openBlock(), _createBlock(_component_LineButton, {
                        key: 0,
                        onClick: _ctx.login,
                        "data-cy": "lineLoginButton"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.loginButtonLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true),
                  (
              authenticatorRegistration.authentication_type ===
              'external_uid_digest'
            )
                    ? (_openBlock(), _createBlock(_component_BaseButton, {
                        key: 1,
                        type: "button",
                        buttonClass: "main",
                        class: "px-6 py-2 mb-2",
                        onClick: _ctx.login,
                        "data-cy": "otherLoginButton"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.loginButtonLabel), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("p", {
                class: "pb-4 text-gray-700 text-xs",
                innerHTML: _ctx.loginDescription
              }, null, 8, _hoisted_10)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}